import React, { useState, useEffect, useCallback } from 'react';
import { Card, Table, Spin, Button, Row, Col, Space, Tag } from 'antd';
import { httpGet, customBaseUrl } from '../../store/http';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import MapProductGLModal from './modal/MapProductGLModal';

const ProductMapping = () => {
    const [mappings, setMappings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const fetchMappings = useCallback(async () => {
        setLoading(true);
        try {
            const res = await httpGet(`${customBaseUrl.tranv2}/api/v1/product-codes/mappings`);
            if (res.success) {
                setMappings(Array.isArray(res.data) ? res.data : []);
            } else {
                setMappings([]);
                NotificationManager.error(res.message || 'Failed to fetch product mappings.');
            }
        } catch (error) {
            setMappings([]);
            NotificationManager.error('Error fetching product mappings.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMappings();
    }, [fetchMappings]);

    const columns = [
        { title: 'Product Code', dataIndex: 'productCode', key: 'productCode', fixed: 'left' },
        { title: 'Debit GL', dataIndex: 'debitGlAccountCode', key: 'debitGlAccountCode' },
        { title: 'Credit GL', dataIndex: 'creditGlAccountCode', key: 'creditGlAccountCode' },
        {
            title: 'Account Type',
            dataIndex: 'accountType',
            key: 'accountType',
            render: (type) => <Tag color="blue">{type}</Tag>
        },
        { title: 'Priority', dataIndex: 'priority', key: 'priority' },
        {
            title: 'Effective Date',
            dataIndex: 'effectiveDate',
            key: 'effectiveDate',
            render: (text) => text ? moment(text).format('YYYY-MM-DD') : '-'
        },
        {
            title: 'Expiry Date',
            dataIndex: 'expiryDate',
            key: 'expiryDate',
            render: (text) => text ? moment(text).format('YYYY-MM-DD') : '-'
        },
    ];

    return (
        <div style={{ padding: '0 0px' }}>
            <Card
                title="Product to GL Mappings"
                style={{ marginBottom: 24 }}
                extra={
                    <Button
                        type="primary"
                        onClick={() => setShowModal(true)}
                        style={{ background: '#FF4B01', border: 'none', borderRadius: 4 }}
                    >
                        Map Product to GL
                    </Button>
                }
            >
                <Spin spinning={loading}>
                    <Table
                        dataSource={mappings}
                        columns={columns}
                        rowKey={(record) => `${record.productCode}-${record.accountType}-${record.priority}`}
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 1000 }}
                    />
                </Spin>
            </Card>

            <MapProductGLModal
                showModal={showModal}
                hideModal={() => setShowModal(false)}
                onSuccess={fetchMappings}
            />
        </div>
    );
};

export default ProductMapping;
